import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-month-picker-calendar/dist/react-month-picker-input.css";

export default class ShortTermHiredReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            url: '/api/v1/portal/portal-admin/short-term-hired-report/',
            totalJobs: [],
            selectedStartDate: moment().toDate(),
            selectedEndDate: moment().toDate(),
            downloadReportName: 'Short Term Hired Report',
            isDownloading: false,
        };
        this.handleselectedStartDateChange = this.handleselectedStartDateChange.bind(this);
        this.handleselectedEndDateChange = this.handleselectedEndDateChange.bind(this);
    }
    handleselectedStartDateChange(date) {
        this.setState({ selectedStartDate: date })
    }
    handleselectedEndDateChange(date) {
        this.setState({ selectedEndDate: date })
    }
    async handleTotalJobsSetToInvoiceReport(e) {
        this.setState({ isLoading: true });

        const url = this.state.url + moment(this.state.selectedStartDate).format("YYYY-MM-DD") + '/' + moment(this.state.selectedEndDate).format("YYYY-MM-DD");

        try {
            const response = await fetch(url, {
                method: "GET",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Authorization": 'Bearer ' + window.api_token,
                    "Accept": 'application/json'
                },
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({
                    totalJobs: data,
                    isLoading: false
                });
            } else {
                this.setState({
                    totalJobs: [],
                    isLoading: false
                });
            }
        } catch (error) {
            this.setState({
                totalJobs: [],
                isLoading: false
            });
        }
    }
    downloadableCsvDataTotalJobsRaisedByUser(filename, text) {
        let filenamed = filename + " FROM " + moment(this.state.selectedStartDate).format("YYYY-MM-DD") + " TO " + moment(this.state.selectedEndDate).format("YYYY-MM-DD") + ".csv";
        let textdata = "Requested Date, Scheduled Date, Customer, Job Number, Service Post Code, Qty, Unit Type, Job Option, 3 Words\n" + text;
        let element = document.createElement('a');
        element.setAttribute(
            'href',
            'data:text/plain;charset=utf-8,' + encodeURIComponent(textdata)
        );
        element.setAttribute('download', filenamed);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    render() {
        let totalJobs = [];
        let shortTermHired = 0;
        let downloadableCsvDataInvoiced = "";
        if (this.state.totalJobs.length > 0) {
            this.state.totalJobs.map((currentJob, index) => {
                totalJobs.push(
                    <tr key={index}>
                        <td>{moment(currentJob.requested_date).format('DD/MM/YYYY')}</td>
                        <td>{currentJob.scheduled_date ? moment(currentJob.scheduled_date, "DD/MM/YYYY hh:mm A").format('DD-MM-YYYY hh:mm A') : '-'}</td>
                        <td>{currentJob.customer_name}</td>
                        <td>
                            <a href={`/jobs/view/${currentJob.job_number}`} target="_blank" rel="noopener noreferrer">
                                {currentJob.job_number}
                            </a>
                        </td>
                        <td>{currentJob.service_postcode}</td>
                        <td>{currentJob.qty}</td>
                        <td>{currentJob.unit_type}</td>
                        <td>{currentJob.job_option}</td>
                        <td>{currentJob.three_words_of_dropoff_address}</td>
                    </tr>
                );

                shortTermHired += parseInt(currentJob.qty);
                downloadableCsvDataInvoiced +=
                    moment(currentJob.requested_date).format('YYYY-MM-DD') + ',' +
                    (currentJob.scheduled_date ? moment(currentJob.scheduled_date, "DD/MM/YYYY hh:mm A").format('DD-MM-YYYY hh:mm A') : '-') + ',' +
                    currentJob.customer_name + ',' +
                    currentJob.job_number + ',' +
                    currentJob.service_postcode + ',' +
                    currentJob.qty + ',' +
                    currentJob.unit_type + ',' +
                    currentJob.job_option + ',' +
                    currentJob.three_words_of_dropoff_address + 
                    '\n';
            });
        }
        else {
            totalJobs.push(
                <tr key='no-records'><td colSpan="8" className='text-center'>No Records</td></tr>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Short Term Hired Report</h2>
                    <br /><br /><br />
                </div>
                <div className="row">
                    <div className="col-md-1">
                        From Date:
                    </div>
                    <div className="col-md-1">
                        To Date:
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-1">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleselectedStartDateChange} selected={this.state.selectedStartDate} />
                    </div>
                    <div className="col-md-1">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleselectedEndDateChange} selected={this.state.selectedEndDate} />
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-success btn-lg" disabled={this.state.isLoading ? true : false} onClick={(e) => this.handleTotalJobsSetToInvoiceReport(e)}>
                                <i className="fa fa-download"></i> Generate Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg" disabled={this.state.isDownloading ? true : false} onClick={(e) => { this.downloadableCsvDataTotalJobsRaisedByUser(this.state.downloadReportName, downloadableCsvDataInvoiced) }}>
                                <i className="fa fa-download"></i> Download Report {this.state.isDownloading ? <i className="fa fa-spinner fa-pulse"></i> : ''}
                            </button>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <h4 className="alert alert-info">Short Term Hired from {moment(this.state.selectedStartDate).format("DD/MM/YYYY")} to {moment(this.state.selectedEndDate).format("DD/MM/YYYY")} are : <b>{shortTermHired}</b></h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-10 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead>
                                    <tr>
                                        <th>Requested Date</th>
                                        <th>Scheduled Date</th>
                                        <th>Customer</th>
                                        <th>Job Number</th>
                                        <th>Service Post Code</th>
                                        <th>Qty</th>
                                        <th>Unit Type</th>
                                        <th>Job Option</th>
                                        <th>3 Words</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.isLoading ? (<tr><td colSpan="8"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) : totalJobs}
                                </tbody>
                            </table>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-short_term_hired_report')) {
    ReactDOM.render(
        <ShortTermHiredReport message_if_none='Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-short_term_hired_report')
    );
}
